import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";
import { FAQS } from "@/data/site";



const Faq = () => (
  <section id="faq" data-testid="faq-section" className="scroll-mt-24 px-4 pb-24 pt-4 sm:px-6 lg:px-8">
    <div className="mx-auto max-w-3xl">
      <Reveal className="mb-10 text-center">
        <p className="mb-3 text-xs font-bold uppercase tracking-widest text-tracksy-orange">FAQ</p>
        <h2 className="font-heading text-3xl font-bold tracking-tight text-tracksy-ink sm:text-4xl">
          Frequently asked questions
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="mb-3 rounded-2xl border border-black/5 bg-white px-6 shadow-subtle data-[state=open]:border-tracksy-orange/40"
            >
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="py-5 text-left font-heading text-base font-bold text-tracksy-ink hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm leading-relaxed text-tracksy-sub">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
